module.exports = __webpack_public_path__ + "static/media/19ESCAP33.4050a029.jpg";